import { createSelector, Selector } from "@reduxjs/toolkit";
import { RootState } from "..";
import { RecurringIssue } from "./types";
import { recurringIssueAdapter } from "./recurringIssueSlice";

const selectSelf = (state: RootState) => state.recurringIssue;

export const selectCurrentRecurringIssue: Selector<
  RootState,
  RecurringIssue | undefined
> = createSelector(selectSelf, ({ entities, selectedId }) => {
  if (selectedId) return entities[selectedId];
  return undefined;
});

export const selectSelectedRecurringIssueId: Selector<
  RootState,
  RecurringIssue["id"] | undefined
> = createSelector(selectSelf, ({ selectedId }) => selectedId);

export const {
  selectAll: selectAllRecurringIssues,
  selectById: selectRecurringIssueById,
  selectEntities: selectRecurringIssueEntities,
  selectIds: selectAllRecurringIssueIds,
} = recurringIssueAdapter.getSelectors(
  (state: RootState) => state.recurringIssue,
);
